"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tag = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./Tag.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Tags are compact elements that represent an attribute related to the content
 * the tag is displayed with (eg. in a Card or a table row).
 *
 * Tags can be customized by selecting a color or size from a range of options.
 *
 * All HTML attributes are supported, and all unhandled props, including refs,
 * are forwarded to the root `Text` component.
 */
const Tag = ({
  variant = 'grey',
  size = 'small',
  transform = 'uppercase',
  ...otherProps
}) => (0, _pragma.createFelaElement)(_.Text, _extends({
  as: "div",
  color: variant === 'greyInverse' ? 'text.2' : 'text.3',
  css: css.tag,
  cssProps: {
    variant,
    size
  },
  lineHeight: "xs",
  size: "meta",
  transform: transform,
  weight: "bold"
}, otherProps));

exports.Tag = Tag;
Tag.displayName = 'Tag';
var _default = Tag;
exports.default = _default;
//# sourceMappingURL=Tag.js.map